import React from 'react';
import './ServiceCard.css';

const ServiceCard = ({ icon, title, description, professionals }) => {
    return (
        <div className="service-card">
            <div className="hexagon-container">
                <div className="hexagon-content">
                    <div className="service-icon">{icon}</div>
                    <h3 className="service-title">{title}</h3>
                    <p className="service-description">{description}</p>
                    <div className="service-meta">
                        <span className="professionals-count">{professionals}+</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ServiceCard;
